module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_foilGoldHover-d63b0363e629536b9f53cadd189c1d14.jpg";